import { Time } from '../constants';

export function todayWithZeroTime() {
	const today = new Date();
	return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

export function translateDateForSQLServer(date?: Date | string) {
	return translateDate(date || new Date(), 'toSQL');
}

export function translateDateForWebISO(date?: Date | string) {
	return translateDate(date || new Date(), 'fromSQL');
}

export function translateDate(date: Date | string, mode: 'fromSQL' | 'toSQL'): Date {
	if (typeof date === 'string') {
		date = new Date(date);
	}

	const offset = date.getTimezoneOffset();
	const minute = Time.minuteInMilliseconds;
	const time = new Date(date).getTime();

	switch (mode) {
		case 'fromSQL':
			return new Date(time + offset * minute);

		case 'toSQL':
			return new Date(time - offset * minute);

		default:
			return new Date(date);
	}
}
